import React from "react";
import "../style/login.scss";
import { googleServer } from "../commons/commonVariable";

interface GoogleSignInButtonProps {
    className?: string;
}

const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({className }) => {
    const handleLogin = async () => {
        try {
            const response = await fetch(googleServer + '/user/signUp', {
                method: 'POST',
                credentials: 'include',
            });
            const data = await response.json();
            if (data.status === 201) {
                window.location.href = data.url;
            }
        } catch (error) {
            console.error('로그인 중 오류가 발생했습니다:', error);
        }
    };

    return (
        <button 
            onClick={handleLogin} 
            className={`sign-in-button-for-google ${className || ''}`} 
            type="button"
        >
            <img
                width='30'
                src={'https://storage.googleapis.com/aemr4all.com/Google_G_logo.png'}
                alt="google_logo"
            />
            <p>Sign in with Google</p>
        </button>
    );
};

export default GoogleSignInButton; 